__turbopack_context__.v({
  "content": "THSCHq_content",
  "placeholder": "THSCHq_placeholder",
  "reversed": "THSCHq_reversed",
  "section": "THSCHq_section",
  "section-bg-faded-aqua": "THSCHq_section-bg-faded-aqua",
  "section-bg-faded-berry": "THSCHq_section-bg-faded-berry",
  "section-bg-faded-green": "THSCHq_section-bg-faded-green",
  "section-bg-faded-smoke": "THSCHq_section-bg-faded-smoke",
  "section-bg-light-aqua": "THSCHq_section-bg-light-aqua",
  "section-bg-light-berry": "THSCHq_section-bg-light-berry",
  "section-bg-light-green": "THSCHq_section-bg-light-green",
  "section-bg-light-smoke": "THSCHq_section-bg-light-smoke",
  "section-bg-white": "THSCHq_section-bg-white",
  "wrapper": "THSCHq_wrapper",
});
